import axios from 'axios';
import https from 'https';

axios.defaults.baseURL = `${process.env.VUE_APP_CORE_API_URL}`;
axios.defaults.headers.common.Accept = 'application/json';
axios.httpsAgent = https.Agent({
  rejectUnauthorized: false,
});
axios.setCoreUrl = () => {
  axios.defaults.baseURL = process.env.VUE_APP_CORE_API_URL;
}
axios.setSxEnvironment = (environment) => {
  console.log('set sx environment')
  console.log(environment)
  console.log(process.env.VUE_APP_SERVER_PREFIX)
  console.log(process.env.VUE_APP_API_ADDRESS)
  console.log(process.env)
  axios.defaults.baseURL = `${process.env.VUE_APP_SERVER_PREFIX}${environment}.${process.env.VUE_APP_API_ADDRESS}`;
};
axios.setBearer = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

export default axios;
